export const SUGGESTED_PROGRAMS = [];

export const TRAVEL_PROGRAM = {
	TITLE: 'Travel Program + Concierge',
	DESCRIPTION:
		'Transform business travel into a seamless experience by empowering employees to expense office commutes, airport transfers, and all work-related journeys, integrating travel effortlessly into their professional lives. Efficiently manage transportation needs for employees, customers, and guests by easily requesting and monitoring rides. Additionally, streamline business operations by organizing deliveries with convenience and precision.',
	USE_THIS_PROGRAM_FOR: 'Use this program for:',
	PURPOSE: [
		'Office Commute',
		'Domestic business travel',
		'Local business rides',
		'Courtesy rides for customers or workers',
		'Premium rides for executives or VIPs',
		'Delivery options',
	],
};

export const CONCIERGE = {
	TITLE: 'Concierge',
	DESCRIPTION:
		'Efficiently manage transportation needs for employees, customers, and guests by easily requesting and monitoring rides. Additionally, streamline business operations by organizing deliveries with convenience and precision.',
};

export const PROGRAMS = [
	{ label: TRAVEL_PROGRAM.TITLE, value: 'travel-program' },
	{ label: CONCIERGE.TITLE, value: 'concierge' },
];
